import React, { createContext, useContext, useEffect, useMemo } from 'react';

/**
 * Theme mechanics — pinned to light.
 *
 * The site used to read localStorage, fall back to prefers-color-scheme,
 * and expose a toggle in the navbar. It now ships light-only, so the
 * provider stamps `data-theme="light"` and nothing else reads or writes a
 * preference. The stamp still happens because the stylesheet keys its
 * whole palette off that attribute.
 *
 * The context is kept, with setTheme/toggleTheme as no-ops, so any consumer
 * still calling them keeps working rather than throwing.
 */

const THEME = 'light';

const noop = () => {};
const ThemeContext = createContext({ theme: THEME, setTheme: noop, toggleTheme: noop });

export const ThemeProvider = ({ children }) => {
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', THEME);
  }, []);

  const value = useMemo(() => ({ theme: THEME, setTheme: noop, toggleTheme: noop }), []);

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => useContext(ThemeContext);

export default ThemeProvider;
